import axios from "axios";
import { getCookie } from "../../../App";
import { domain } from "../../Links/Links";

export async function TokenSendRequest(
  token,
  receivingAddress,
  amount,
  memo,
  setTokenSendRequestStatus,
  setActive,
  setSendStatus,
  navigate,
  setSendTokenError,
  selectedUSDTNetwork
) {
  setTokenSendRequestStatus(true);

  token = token.toUpperCase();

  try {
    const { data } = await axios.post(
      domain + "/send_token/",
      {
        token,
        receiving_address: receivingAddress,
        amount,
        memo,
        ...(selectedUSDTNetwork && { network: selectedUSDTNetwork }),
      },
      {
        withCredentials: true,
        headers: {
          "X-CSRFToken": getCookie("csrf_token"),
        },
      }
    );


    if (data.ok) {
      setTokenSendRequestStatus(false);
      setActive(false);

      setTimeout(() => {
        setSendStatus(false);
        navigate("/history");
      }, 300);
    } else if (data.invalid_address) {
      setTokenSendRequestStatus(false);
      setSendTokenError({
        status: true,
        text: "The receiver address is invalid.",
      });
    } else if (data.not_enough_balance) {
      setTokenSendRequestStatus(false);
      setSendTokenError({
        status: true,
        text: "not enough balance",
      });
    } else if (data.network_error) {
      setTokenSendRequestStatus(false);
      setSendTokenError({
        status: true,
        text: "select a vaild network",
      });
    } else {
      setTokenSendRequestStatus(false);
      setSendTokenError({
        status: true,
        text: "Something went wrong.",
      });
    }

  } catch (error) {
    console.error(error);
    setTokenSendRequestStatus(false);
  }
}